import React, { useRef, useState } from "react";
import {
    Grid,
    Box,
    IconButton } from "../ui";
import DeleteIcon from "../ui/icons/Delete";
import {
  isEmpty
} from "../../constants/constant";

const SingleImageUploader = ({ baseUrl, originalImage, image, setImage, deletOriginal }) => {

    const fileInputRef = useRef(null);
    // handle image selection
    const handleInputChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage({
                file,
                url: URL.createObjectURL(file),
            });
        }
        e.target.value = null;
    };

    // delete image
    const handleDeleteImage = () => {
        setImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    return (
        <Grid container spacing={1} direction="row"
            justifyContent="flex-end"
            alignItems="flex-end">
            <Grid item md={6} sm={6} lg={6} xs={12}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end", // 👈 align horizontally right
                        alignItems: "flex-end", // 👈 align vertically bottom
                        width: "100%",
                        minHeight: "100px",
                        borderRadius: 2,
                        gap: 1,
                    }}
                >
                    {/* Preview image (if selected) */}
                    {image && (
                        <Box
                            sx={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={image.url}
                                alt="preview"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "1px solid lightgray",
                                }}
                            />
                            <IconButton
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    backgroundColor: "#fff",
                                    border: "1px solid lightgray",
                                }}
                                onClick={handleDeleteImage}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    )}

                    {originalImage && (
                        <Box
                            sx={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={`${baseUrl}${originalImage}`}
                                alt="preview"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "1px solid lightgray",
                                }}
                            />
                            <IconButton
                                size="small"
                                sx={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    backgroundColor: "#fff",
                                    border: "1px solid lightgray",
                                }}
                                onClick={deletOriginal}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    )}

                    {/* Upload input */}
                    {
                        isEmpty(originalImage) &&
                        <input
                            ref={fileInputRef}
                            accept="image/*"
                            id="imgPath"
                            name="imgPath"
                            type="file"
                            onChange={handleInputChange}
                            style={{
                                border: "1px solid lightgray",
                                padding: "5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                height: "30px",
                            }}
                        />
                    }

                </Box>
            </Grid>
        </Grid>
    );
};

export default SingleImageUploader;
